import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { useClassroomSessionStore } from "stores/v2/classroomSessionStore";

const StartMonitoringButton = React.memo((props) => {
	const handleClick = (ev) => {
		ev.stopPropagation();
		useClassroomSessionStore.getState().handleShowStartClassModal({
			show: true,
			classroomName: props.classroomName,
			monitoring: true,
		});
	};

	return (
		<button className={clsx("button-callToAction--green Classroom_start--wide", "Classroom_sart--monitor")} onClick={handleClick}>
			Start Monitoring
		</button>
	);
});
StartMonitoringButton.displayName = "StartMonitoringButton";

StartMonitoringButton.propTypes = {
	classroomName: PropTypes.string,
};

export default StartMonitoringButton;
